module.exports = __webpack_public_path__ + "img/image-site-marsac.e057f154.jpg";